module.exports = __webpack_public_path__ + "img/login.f2d265b2.png";